import { useNavigate } from 'react-router-dom';
import { Tooltip, Button, IconButton } from '@crazyegginc/hatch';
import { useMetric, useAuthContext, useModal, usePermissions, useManageSubscriptionPath } from '/src/hooks';
import { FEATURES, CAPABILITY_REASONS } from '/src/features/_global/constants';
import { EnterprisePlanModal } from '/src/features/account/components/modals/EnterprisePlanModal';
import { isSemrush } from '/src/utils/semrush';

import { ReactComponent as UpgradeIcon } from '@crazyegginc/hatch/dist/images/icon-rocket-outline.svg';

export function NavUpgradeButton({ expanded = true, textContent, isUpgrade = true, cta_id = 'navbar' }) {
  const navigate = useNavigate();
  const trackMetric = useMetric();
  const { currentUser } = useAuthContext();
  const permissions = usePermissions();
  const modal = useModal();
  const manageSubscriptionPath = useManageSubscriptionPath();

  const { allowed: canChangePlan, reason } = permissions.can('changePlan', FEATURES.BILLING);
  const showEnterpriseModal = !canChangePlan && reason === CAPABILITY_REASONS.CONTACT_SUPPORT && !isSemrush;

  const storePreUpgradeState = () => {
    // Store current subscription state before navigating to billing
    const subscriptions = [];
    if (currentUser?.subscriptions?.snapshots) {
      subscriptions.push({
        paymentPlan: {
          isFree: currentUser.subscriptions.snapshots.paymentPlan?.isFree,
          isFreemium: currentUser.subscriptions.snapshots.paymentPlan?.isFreemium,
          isTrial: currentUser.subscriptions.snapshots.paymentPlan?.isTrial,
          name: currentUser.subscriptions.snapshots.paymentPlan?.name,
        },
      });
    }
    if (currentUser?.subscriptions?.recordings) {
      subscriptions.push({
        paymentPlan: {
          isFree: currentUser.subscriptions.recordings.paymentPlan?.isFree,
          isFreemium: currentUser.subscriptions.recordings.paymentPlan?.isFreemium,
          isTrial: currentUser.subscriptions.recordings.paymentPlan?.isTrial,
          name: currentUser.subscriptions.recordings.paymentPlan?.name,
        },
      });
    }
    const subscriptionData = {
      subscriptions,
    };

    sessionStorage.setItem('ce_pre_upgrade_state', JSON.stringify(subscriptionData));
    sessionStorage.setItem('ce_upgrade_flow', 'true');
    sessionStorage.setItem('ce_upgrade_timestamp', Date.now().toString());
  };

  return expanded ? (
    <Button
      variant="secondary"
      className="!h-10 w-[150px] justify-center"
      onMouseDown={() => {
        if (isUpgrade) {
          trackMetric('upgrade_cta_click', cta_id);
        }
      }}
      onClick={() => {
        if (showEnterpriseModal) {
          modal.show(<EnterprisePlanModal />);
        } else {
          if (isUpgrade) {
            storePreUpgradeState();
          }
          navigate(manageSubscriptionPath);
        }
      }}
      style={{ outlineColor: 'white' }}
    >
      {textContent}
    </Button>
  ) : (
    <Tooltip placement="right" tooltipContent={textContent}>
      <IconButton
        className="h-10 w-10 rounded border-solitude-500 bg-solitude-500 text-dodger-blue-500 hover:border-dodger-blue-500"
        icon={<UpgradeIcon className="h-5 w-5 fill-current " />}
        label={`${textContent} Button`}
        theme="dark"
        onMouseDown={() => {
          if (isUpgrade) {
            trackMetric('upgrade_cta_click', cta_id);
          }
        }}
        onClick={() => {
          if (showEnterpriseModal) {
            modal.show(<EnterprisePlanModal />);
          } else {
            if (isUpgrade) {
              storePreUpgradeState();
            }
            navigate(manageSubscriptionPath);
          }
        }}
      />
    </Tooltip>
  );
}
